import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-regatta-twilight-races',
  imports: [],
  templateUrl: './regatta-twilight-races.component.html',
  styleUrl: './regatta-twilight-races.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegattaTwilightRacesComponent {

}
